import fieldsFromModelMixin from "@/components/common/mini-table/mixins/fields-from-model-mixin";
import sortMixin from "@/components/common/mini-table/mixins/sort-mixin";

export default {
    mixins: [fieldsFromModelMixin, sortMixin],
    props: {
        disableFirstIndexColumn: {
            type: Boolean,
            default: false
        },
        //开启行首自定义列
        withCustomActionsHeadOfRow: {
            type: Boolean,
            default: false
        },
        //行首自定义列的label
        customHeadOfRowLabel: {
            type: String,
            default: '功能'
        },
        //开启行末尾自定义列
        withCustomActionsEndOfRow: {
            type: Boolean,
            default: false
        },
        //行末尾自定义列的label
        customEndOfRowLabel: {
            type: String,
            default: '功能'
        },
        sortable: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        noRequireWarning: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            inputConfigList: [],
            hasFieldEdit: false,
        }
    },
    methods: {
        initInputConfigList: function () {
            if (this.localFields) {
                this.localFields.forEach(item => {
                    let config, isString = false;
                    if (typeof (item) === 'string') {
                        config = {
                            label: item,
                            name: item,
                        };
                        isString = true;
                    } else {
                        config = this.deepCopy(item);
                        config.name = item.key;
                    }
                    if (!config.type) {
                        config.type = 'input';
                        if (!isString) {
                            item.type = 'input';
                        }
                    }
                    if (config.optionFrom) {
                        this.queryOptions(config, item);
                    }
                    if (config.optionsFromDict) {
                        if (!this.$store.state.dictionaryEnumStore.dictionary.has(config.optionsFromDict)) {
                            this.$store.dispatch('dictionaryEnumStore/queryDictionary', config.optionsFromDict);
                        }
                    }
                    this.inputConfigList.push(config);
                    if (config.isInput) {
                        this.hasFieldEdit = true;
                    }
                });
                this.rebuildFieldList();
            }
        },
        queryOptions: function (config, item) {
            let optionFrom = config.optionFrom;
            this.$store.dispatch('api/post', {
                url: `${this.$_emApiMixin_moduleBaseApi(optionFrom.entity)}/${optionFrom.entity}/findByFilter`,
                data: {}
            }).then(response => {
                let tempList = [];
                if (response.data.list.length > 0) {
                    for (let temp of response.data.list) {
                        tempList.push({
                            value: temp[optionFrom.value],
                            text: temp[optionFrom.name]
                        })
                    }
                }
                config.options = tempList;
                item.options = tempList;
                this.rebuildFieldList();
            });
        },
        rebuildFieldList() {
            if (this.enableOriginField) {
                this.fieldList = undefined;
                return;
            }
            let tempList = [];
            if (this.enableRowCheck) {
                tempList.push({
                    key: '_row_check',
                    label: ''
                })
            }
            if (!this.disableFirstIndexColumn) {
                tempList.push({
                    key: '_index',
                    label: '#'
                });
            }
            if (this.withCustomActionsHeadOfRow) {
                tempList.push({
                    key: '__headOfRowSlot',
                    label: this.customHeadOfRowLabel
                })
            }
            for (let temp of this.deepCopy(this.localFields)) {
                if (this.sortable && !this.filterable) {
                    temp.sortable = true;
                }
                if (temp.require && !this.noRequireWarning) {
                    temp.variant = 'warning';
                }
                tempList.push(temp);
            }
            if (this.withCustomActionsEndOfRow || this.enableInlineEdit) {
                tempList.push({
                    key: '__endOfRowSlot',
                    label: this.customEndOfRowLabel
                })
            }
            this.fieldList = tempList;
        },
        isActionColumn(column) {
            return column.startsWith('__');
        },
    }
}
